import React, { createContext, useContext, useRef } from 'react';

interface PageTrackingContextValue {
	isFirstLoad: React.MutableRefObject<boolean>;
}

const PageTrackingContext = createContext<PageTrackingContextValue | null>(null);

export const PageTrackingProvider = ({ children }: React.PropsWithChildren): React.ReactElement => {
	const isFirstLoad = useRef(true);

	return <PageTrackingContext.Provider value={{ isFirstLoad }}>{children}</PageTrackingContext.Provider>;
};

export const usePageTrackingContext = (): PageTrackingContextValue => {
	const context = useContext(PageTrackingContext);
	if (!context) {
		throw new Error('usePageTrackingContext must be used within a PageTrackingProvider');
	}
	return context;
};
